import { useEffect } from "react";
import { getBackendStage } from "src/context";

export function useDocumentTitle(initialTitle?: string) {
  const stage = getBackendStage();
  const prefix = stage !== "prod" ? `[${stage.toUpperCase()}] ` : "";
  const suffix = " | Blueprint | Homebound";
  useEffect(() => {
    if (initialTitle) {
      document.title = `${prefix}${initialTitle} ${suffix}`;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (newTitle: string) => (document.title = `${prefix}${newTitle} ${suffix}`);
}
